import { render, staticRenderFns } from "./ExpenseActionButton.vue?vue&type=template&id=b9b5737c"
import script from "./ExpenseActionButton.vue?vue&type=script&lang=js"
export * from "./ExpenseActionButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports